import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3f0ca5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "aria-describedby": "resumen de cuotas",
  class: "w-full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("No."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("cuota")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Valor"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("cuota")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, "Capital"),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Intereses"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("corrientes")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Seguro"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("vida")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Intereses"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Mora")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Gastos"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("cobranza")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Intereses"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("alivio")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Fecha"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("pago")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "table__th"
  }, [
    /*#__PURE__*/_createTextVNode("Estado de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("la cuota")
  ])
], -1))
const _hoisted_3 = { class: "table__td" }
const _hoisted_4 = { class: "table__td" }
const _hoisted_5 = { class: "table__td" }
const _hoisted_6 = { class: "table__td" }
const _hoisted_7 = { class: "table__td" }
const _hoisted_8 = { class: "table__td" }
const _hoisted_9 = { class: "table__td" }
const _hoisted_10 = { class: "table__td" }
const _hoisted_11 = { class: "table__td" }
const _hoisted_12 = { class: "table__td" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.feesSummary.length > 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFees, (fee) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: fee.agreement_id
          }, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(fee.fee_number), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$filters.currency(fee?.fee_value)), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$filters.currency(fee?.fee_capital)), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$filters.currency(fee?.fee_interests_ordinary)), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$filters.currency(fee?.fee_life_insurance)), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$filters.currency(fee?.fee_interests_overdue)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$filters.currency(fee?.fee_outlay_administration)), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$filters.currency(fee?.fee_interests_relief)), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(fee?.fee_date_payment), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(fee?.fee_state), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}